import { useEffect, useState } from "react";
import ApiClient from "../services/ApiClient";
import _ from "lodash";
import { BackofficeUser } from "../types/BackofficeUser";
import { Activity } from "../types/Activity";

function useActivitiesFetching(dataSource: string, backofficeUsers: BackofficeUser[]) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [response, setResponse] = useState<Record<string, any>>();
  const [activities, setActivities] = useState<Activity<BackofficeUser>[]>();
  const [error, setError] = useState("");
  const [totalItems, setTotalItems] = useState<number | null>(null);

  function enrichActivities(response: Record<string, any>) {
    if (!response || !backofficeUsers) {
      return;
    }
    const enrichedActivities = structuredClone(response["hydra:member"]);
    for (let activity of enrichedActivities) {
      if (!!activity.assignedUser) {
        activity.assignedUser = _.find(
          backofficeUsers,
          (backofficeUser) => backofficeUser["@id"] === activity.assignedUser
        );
      }
      if (!!activity.creator) {
        activity.creator = _.find(backofficeUsers, (backofficeUser) => backofficeUser["@id"] === activity.creator);
      }
    }
    setTotalItems(response["hydra:totalItems"]);
    setActivities(enrichedActivities);
    setIsLoading(false);
  }

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const fetchDataResponse: Record<string, any> = await ApiClient.get(`activities?${dataSource}`);
        if (fetchDataResponse) {
          setResponse(fetchDataResponse);
        }
      } catch (error: any) {
        setIsLoading(false);
        setError(error.message);
      }
    }

    fetchData();
  }, [dataSource]);

  useEffect(() => {
    if (!response) {
      return;
    }
    enrichActivities(response);
  }, [response, backofficeUsers]);

  return {
    error,
    isLoading,
    activities,
    totalItems,
  };
}

export default useActivitiesFetching;
